module.exports = __webpack_public_path__ + "static/media/double-chevron.9d7a70da.svg";